import "./styles/Home.css";
import iceCream from "../images/icon/Cone.svg";
import Slush from "../images/icon/Slush.svg";
import Muffin from "../images/icon/Cupcake.svg";
import Pancakes from "../images/icon/Pancake.svg";
import { Link } from "react-router-dom";


export default function MenuBar() {
  return (
    <section className="MenuBar">
      <div className="menu-bar-inner">
        <div className="menu-bar-copy">
          <span className="menu-bar-kicker">THE GOOD STUFF</span>
          <h2>Pick your kind of happy.</h2>
          <p>Frozen favourites, warm treats, and everything worth making room for.</p>
          <Link className="menu-bar-button" to="/menu">
            See the full menu <span aria-hidden="true">↗</span>
          </Link>
        </div>

        <div className="menu-bar-tiles">
          <div className="menu-bar-tile menu-bar-tile-pink"><img src={Slush} alt="" /><span>Slushees</span></div>
          <div className="menu-bar-tile menu-bar-tile-teal"><img src={iceCream} alt="" /><span>Ice cream</span></div>
          <div className="menu-bar-tile menu-bar-tile-yellow"><img src={Muffin} alt="" /><span>Muffins</span></div>
          <div className="menu-bar-tile menu-bar-tile-orange"><img src={Pancakes} alt="" /><span>Pancakes</span></div>
        </div>
      </div>
    </section>
  );
}
